/**
 * UAVTradeZone Modification Record
 *
 * Change ID:    GUEST_ACCESS_BR16_ADMIN_VISITORS
 * Date:         2026-07-06
 * Modified By:  Engineering
 *
 * Description:
 * Client API for the admin Visitors screen (BR-16). Lists anonymous guest_visits
 * (filter by country / channel) and blocks / unblocks an IP or country. Backend:
 * server/routes/admin/guestVisits.js (auth + requireAdmin).
 */

import axios from "axios";
import { getAuthHeaders } from "../../utils/authUtils";
import { config } from "../../config/environment";

const BASE = `${config.apiUrl}/api/admin/guests`;

export interface GuestVisitRow {
  _id: string;
  ip: string;
  country?: string | null;
  region?: string | null;
  city?: string | null;
  userAgent?: string | null;
  referrer?: string | null;
  lastPath?: string | null;
  lastSearch?: string | null;
  utmSource?: string | null;
  utmCampaign?: string | null;
  hits?: number;
  searchCount?: number;
  firstSeen?: string;
  lastSeen?: string;
  blocked?: boolean;
}

export interface GuestVisitsResponse {
  success: boolean;
  data: { items: GuestVisitRow[]; total: number; page: number; pages: number };
}

export type BlockType = "ip" | "country";

export async function getGuestVisits(
  params: { country?: string; channel?: string; page?: number; limit?: number } = {},
): Promise<GuestVisitsResponse> {
  const res = await axios.get<GuestVisitsResponse>(BASE, {
    params,
    headers: getAuthHeaders().headers,
  });
  return res.data;
}

export async function blockGuest(payload: { type: BlockType; value: string; reason?: string }) {
  const res = await axios.post(`${BASE}/block`, payload, { headers: getAuthHeaders().headers });
  return res.data;
}

export async function unblockGuest(payload: { type: BlockType; value: string }) {
  const res = await axios.post(`${BASE}/unblock`, payload, { headers: getAuthHeaders().headers });
  return res.data;
}
